import script from "./WeicomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./WeicomePage.vue?vue&type=script&setup=true&lang=js"

import "./WeicomePage.vue?vue&type=style&index=0&id=2b57beea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b57beea"]])

export default __exports__